<footer>
    <div class="aktuelleVersion">
        <div>Version: {{ aktuelleVersion }}</div>
    </div>
    <div class="links">
        <a class="impressum" target="_blank" rel="noopener noreferrer" [href]="linkImpressum" translate>legal-notice</a>
        <a class="dataprotection" target="_blank" rel="noopener noreferrer" [href]="linkDatenschutzbestimmung"
            translate>privacy-policy</a>
    </div>
</footer>